import { Col, Row } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import InfoBox from "../Components/InfoBox";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import SecurityCard from "../Components/SVG/SecurityCard";
import validation from "./validation";
import DataProtection from "../Components/DataProtection";

function View({ contact, onNext, onBack }) {
  const { t } = useTranslation();
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: contact,
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  return (
    <Layout>
      <Header
        title="Indiquez votre <b>numéro de sécurité sociale</b>"
        highlight="Indiquez votre"
        subtitle="Numéro de Sécurité Sociale"
        onBack={onBack}
      />
      <div className="miltis-form">
        <div className="miltis-form__container">
          <Input
            placeholder={"ex : 185057800608436"}
            label={"N° de sécurité sociale"}
            trim={true}
            {...bindInputProps({
              name: "socialSecurityNumber",
              values,
              ...formProps,
            })}
          />
          {/* <InfoBox
            icon={<SecurityCard />}
            variant="info"
            title={
              "Votre numéro de sécurité sociale se trouve sur votre carte vitale. "
            }
            text={
              "Cette information est strictement confidentielle et utilisée uniquement pour gérer votre contrat."
            }
          /> */}
          <ActionButtons
            disabled={!isEmpty(formProps.errors)}
            onNext={handleSubmit}
            onBack={onBack}
            buttonText="Continuer"
          />
          <DataProtection />
        </div>
      </div>
    </Layout>
  );
}

export default View;
